var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 325,
    height: 325,
    viewBox: "0 0 85.99 85.99",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#2b0000"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.688,
    y: 3.8456e-7,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    y: 3.8456e-7,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    y: 6.6146,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    y: 13.229,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    y: 19.844,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    y: 26.458,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.0000023228,
    y: 39.688,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.0000018919,
    y: 52.917,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.0000013537,
    y: 46.302,
    width: 6.6146,
    height: 6.6146
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fdc230"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.844,
    y: 26.458,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.229,
    y: 33.073,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.229,
    y: 26.458,
    width: 6.6146,
    height: 6.6146
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 19.844,
    y: 33.073,
    width: 6.6146,
    height: 6.6146,
    fill: "#ffc32e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.844,
    y: 39.688,
    width: 6.6146,
    height: 6.6146,
    fill: "#ffc32e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.229,
    y: 39.688,
    width: 6.6146,
    height: 6.6146,
    fill: "#fdc230"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6146,
    y: 39.688,
    width: 6.6146,
    height: 6.6146,
    fill: "#fdc230"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#2b0000"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.0000020996,
    y: 33.073,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6146,
    y: -0.0000029382,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.229,
    y: -0.0000029382,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.844,
    y: -0.0000029382,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.458,
    y: -0.0000029382,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.073,
    y: -0.0000029382,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.0000020996,
    y: 59.531,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.302,
    y: -0.0000029382,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.917,
    y: -0.0000029382,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.0000020996,
    y: 66.146,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.0000020996,
    y: 72.76,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6146,
    y: 72.76,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.229,
    y: 66.146,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.844,
    y: 59.531,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.458,
    y: 52.917,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.073,
    y: 59.531,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.688,
    y: 66.146,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.302,
    y: 72.76,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.917,
    y: 79.375,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.531,
    y: 72.76,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.146,
    y: 66.146,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.76,
    y: 59.531,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.375,
    y: 52.917,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.76,
    y: 46.302,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.146,
    y: 39.687,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.531,
    y: 33.073,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.917,
    y: 26.458,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.146,
    y: 13.229,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.531,
    y: 19.844,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.76,
    y: 6.6146,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.76,
    y: -0.0000047529,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.146,
    y: -0.0000047529,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.531,
    y: -0.0000047529,
    width: 6.6146,
    height: 6.6146
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fdc230"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.229,
    y: 6.6146,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6146,
    y: 6.6146,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.844,
    y: 6.6146,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.073,
    y: 6.6146,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.458,
    y: 6.6146,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.688,
    y: 6.6146,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.917,
    y: 6.6146,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.302,
    y: 6.6146,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.531,
    y: 6.6146,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.229,
    y: 13.229,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6146,
    y: 13.229,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.844,
    y: 13.229,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.073,
    y: 13.229,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.458,
    y: 13.229,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.688,
    y: 13.229,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.917,
    y: 13.229,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.302,
    y: 13.229,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.531,
    y: 13.229,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.229,
    y: 19.844,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6146,
    y: 19.844,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.844,
    y: 19.844,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.073,
    y: 19.844,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.458,
    y: 19.844,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.688,
    y: 19.844,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.073,
    y: 26.458,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.458,
    y: 26.458,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.688,
    y: 26.458,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.073,
    y: 33.073,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.458,
    y: 33.073,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.688,
    y: 33.073,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.073,
    y: 39.688,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.458,
    y: 39.688,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.688,
    y: 39.688,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.073,
    y: 46.302,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.458,
    y: 46.302,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.688,
    y: 46.302,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.229,
    y: 46.302,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6146,
    y: 46.302,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.844,
    y: 46.302,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.917,
    y: 46.302,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.302,
    y: 46.302,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.531,
    y: 46.302,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.688,
    y: 52.917,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.073,
    y: 52.917,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.302,
    y: 52.917,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.531,
    y: 52.917,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.917,
    y: 52.917,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.146,
    y: 52.917,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.917,
    y: 59.531,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.302,
    y: 59.531,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.531,
    y: 59.531,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.917,
    y: 66.146,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.302,
    y: 66.146,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.531,
    y: 66.146,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.229,
    y: 52.917,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6146,
    y: 52.917,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.844,
    y: 52.917,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6146,
    y: 26.458,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6146,
    y: 33.073,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6146,
    y: 59.531,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.229,
    y: 59.531,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6146,
    y: 66.146,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.688,
    y: 59.531,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.917,
    y: 72.76,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.146,
    y: 59.531,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.76,
    y: 52.917,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.146,
    y: 46.302,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.531,
    y: 39.688,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.917,
    y: 39.688,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.302,
    y: 39.688,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.302,
    y: 33.073,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.917,
    y: 33.073,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.302,
    y: 26.458,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.302,
    y: 19.844,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.917,
    y: 19.844,
    width: 6.6146,
    height: 6.6146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.146,
    y: 6.6146,
    width: 6.6146,
    height: 6.6146
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.369c67bba774ca52cfc42d070a25bb52.svg";
export { ForwardRef as ReactComponent };